import React from 'react';

export default function Skeleton({ linhas = 4, larguras = ['70%', '92%', '54%', '80%'] }) {
  return (
    <div className="d-flex flex-column gap-3">
      {Array.from({ length: linhas }).map((_, i) => (
        <span key={i} className="sf-skeleton" style={{ width: larguras[i % larguras.length] }} />
      ))}
    </div>
  );
}
